import { render } from "./Gateways.vue?vue&type=template&id=51ef9c7a&ts=true"
import script from "./Gateways.vue?vue&type=script&setup=true&lang=ts"
export * from "./Gateways.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-two/Gateways.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51ef9c7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51ef9c7a', __exports__)) {
    api.reload('51ef9c7a', __exports__)
  }
  
  module.hot.accept("./Gateways.vue?vue&type=template&id=51ef9c7a&ts=true", () => {
    api.rerender('51ef9c7a', render)
  })

}


export default __exports__